import adBlocker from 'just-detect-adblock'
import { compose, withProps, withState } from 'recompose'

type Props = {
  withAdBlocker: () => void
  adBlockDetected?: boolean
  setAdBlockDetected?: () => void
}

export default compose<Props, {}>(
  withState('adBlockDetected', 'setAdBlockDetected', adBlocker.isDetected()),
  withProps(({ adBlockDetected }) => {
    const adBlockMessageDismissed =
      window.sessionStorage.getItem('ADBLOCK_MESSAGE_DISMISSED') === 'true'
    if (adBlockDetected && !adBlockMessageDismissed) {
      window.sessionStorage.setItem('ADBLOCK_MESSAGE_DISMISSED', 'false')
      return {
        adBlockDetected: true,
      }
    } else {
      return {
        adBlockDetected: false,
      }
    }
  }),
)
